import { render } from "./Hero.vue?vue&type=template&id=598a1ff5"
const script = {}
script.render = render

export default script